import { render, staticRenderFns } from "./carRegion.vue?vue&type=template&id=3c433d50&scoped=true&"
import script from "./carRegion.vue?vue&type=script&lang=js&"
export * from "./carRegion.vue?vue&type=script&lang=js&"
import style0 from "./carRegion.vue?vue&type=style&index=0&id=3c433d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c433d50",
  null
  
)

export default component.exports